import { Imagen } from "./imagen";

export class ListaDeseos {
    public lideId: number;
    public tercId_SicaTercero: number;
    public partId: number;
    public codigoParte: string;
    public estado: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public usuarioCreador: string;
    public usuarioModificador: string;
    public imagen: Imagen;

    constructor(){}
}
